function head(arr) {
    return arr[0];
}

export { head };
